import React from 'react';
import { AlertCircle } from 'lucide-react';
import './JabutiIndicator.css';

interface JabutiData {
  score: number;
  level: 'low' | 'medium' | 'high';
  indicators: string[];
}

interface JabutiIndicatorProps {
  jabuti?: JabutiData;
  compact?: boolean;
}

export default function JabutiIndicator({ jabuti, compact = false }: JabutiIndicatorProps) {
  if (!jabuti || jabuti.level === 'low') return null;

  if (compact) {
    return (
      <div className={`jabuti-badge jabuti-${jabuti.level}`} title={jabuti.indicators.join('; ')}>
        <AlertCircle size={14} />
      </div>
    );
  }

  return (
    <div className={`jabuti-alert jabuti-${jabuti.level}`}>
      <div className="jabuti-header">
        <AlertCircle size={18} />
        <span className="jabuti-title">
          {jabuti.level === 'high' && 'Risco alto de jabutis'}
          {jabuti.level === 'medium' && 'Risco médio de jabutis'}
        </span>
        <span className="jabuti-score">{Math.round(jabuti.score)}%</span>
      </div>
      {jabuti.indicators.length > 0 && (
        <ul className="jabuti-indicators">
          {jabuti.indicators.map((indicator, idx) => (
            <li key={idx}>{indicator}</li>
          ))}
        </ul>
      )}
    </div>
  );
}
